import { Action } from '@ngrx/store';

export const getDummyAction = (): Action => ({ type: 'NO_ACTION' });
